<p-toast key="global-toasts"/>
<p-confirmpopup
    key="confirmPopup"
></p-confirmpopup>
<p-confirmDialog
    key="confirmDialog"
    position="top"
    acceptLabel="{{ 'yes' | translate }}"
    rejectLabel="{{ 'no' | translate }}"
></p-confirmDialog>

@let displayLayout = displayLayout$ | async;
@if (displayLayout === true) {
    <app-layout [backendUrl]="backendUrl">
        <router-outlet main-panel></router-outlet>
    </app-layout>
} @else {
    <app-embed-layout>
        <router-outlet></router-outlet>
    </app-embed-layout>
}
